import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import '../../services/GlobalVariables';

const API_URL = global.SET_API_URL + 'attendance/mobile-report';

const initialState = {
    rows: [],
    isLoading: false,
    isError: false,
    message: ''
};

export const getMobileAttendanceReport = createAsyncThunk('mobileAttendanceReport/get', async (filters, thunkAPI) => {
    try {
        const query = new URLSearchParams();

        if (filters?.targetDate) {
            query.set('targetDate', filters.targetDate);
        }

        if (filters?.fromDate) {
            query.set('fromDate', filters.fromDate);
        }

        if (filters?.toDate) {
            query.set('toDate', filters.toDate);
        }

        if (filters?.unitID) {
            query.set('unitID', filters.unitID);
        }

        if (filters?.siteID) {
            query.set('siteID', filters.siteID);
        }

        const result = await axios.get(`${API_URL}?${query.toString()}`);
        return result.data;
    } catch (error) {
        const message = (error.response && error.response.data && (error.response.data.message || error.response.data.error)) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

const mobileAttendanceReportSlice = createSlice({
    name: 'mobileAttendanceReport',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getMobileAttendanceReport.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
                state.message = '';
            })
            .addCase(getMobileAttendanceReport.fulfilled, (state, action) => {
                state.isLoading = false;
                state.rows = action.payload || [];
            })
            .addCase(getMobileAttendanceReport.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
                state.rows = [];
            });
    }
});

export default mobileAttendanceReportSlice.reducer;